// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lp-0";
export var assigneeDetails = "_lp-1";
export var assigneeInfo = "_lp-2";
export var dropdownContainer = "_lp-4";
export var dropdownImage = "_lp-5";
export var editAssigneeInfo = "_lp-3";
export var editAssigneeModalContainer = "_lp-6";
export var hidden = "_lp-8";
export var input = "_lp-7";